import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { AUTHENTICATED_HOME_ROUTE, createFileRoute, redirect } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';
import { validateSignUpSearch } from './-publicSearch';

const LazySignUpEmail = lazy(() => import('./-sign-up-email').then((module) => ({ default: module.SignUpEmail })));

const SignUpEmailRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazySignUpEmail />
  </Suspense>
);

export const Route = createFileRoute('/sign-up/email')({
  beforeLoad: async ({ context }) => {
    if (context.authentication?.isAuthenticated) {
      throw redirect({ to: AUTHENTICATED_HOME_ROUTE });
    }
  },
  component: SignUpEmailRouteComponent,
  validateSearch: validateSignUpSearch,
});
